module.exports = __webpack_public_path__ + "static/media/ProjectStep2.7638f420.png";